/** Today (daily) panel section for TodayViewPanels. */
import Panel from '@/components/ui/Panel';
import { AddTaskRow } from '@/components/ui/AddTaskRow';
import TodaySectionList from './TodaySectionList';
import TodayPanelEmptyMessage from './TodayPanelEmptyMessage';
import {
  TODAY_PANEL_A11Y,
  TODAY_PANEL_FLAT_CLASS,
} from './todayViewPanelsHelpers';

export function TodayMainPanelSection({
  t,
  isBattlefield,
  displayTodayTasks,
  todayTasks,
  allTasksCount,
  completedTodayTasks,
  topActionableTaskId,
  tasksMap,
  selectedTaskIds,
  setSelectedTaskIds,
  swipeTeaserTaskId,
  onSwipeTeaserEnd,
  todayDefaultTaskData,
}) {
  return (
    <Panel
      flat
      contentClassName={TODAY_PANEL_FLAT_CLASS}
      testId="panel-today"
      title={t('todayviewcontent.today', 'Today')}
      count={displayTodayTasks.length}
      {...TODAY_PANEL_A11Y}
    >
      <TodaySectionList
        isBattlefield={isBattlefield}
        variant="sortable"
        tasks={displayTodayTasks}
        totalTasksCount={todayTasks.length}
        listId="mobile-today-list"
        taskType="daily-task"
        topActionableTaskId={topActionableTaskId}
        showPlayButtonAlways
        tasksMap={tasksMap}
        inProgressMessage={t(
          'todayviewcontent.todayInProgress',
          'Your action for today is in progress!',
        )}
        emptyMessage={
          <TodayPanelEmptyMessage
            t={t}
            allTasksCount={allTasksCount}
            completedTodayCount={completedTodayTasks.length}
          />
        }
        selectedTaskIds={selectedTaskIds}
        onSelectionChange={setSelectedTaskIds}
        swipeTeaserTaskId={swipeTeaserTaskId}
        onSwipeTeaserEnd={onSwipeTeaserEnd}
      />
      <AddTaskRow
        tasks={displayTodayTasks}
        defaultTaskData={todayDefaultTaskData}
        label={t(
          'todayviewcontent.addTaskToday',
          'Taak voor vandaag toevoegen',
        )}
        tabIndex={0}
      />
    </Panel>
  );
}
